import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import { ContentReaction } from "scmp-app/components/content/content-reaction";
import {
  StyledButton as ContentReactionButton,
  Count as ContentReactionCount,
  StyledIconUpvoteOn,
} from "scmp-app/components/content/content-reaction/content-reaction-display/styles";

export type ContentReactionProps = {
  $size?: "normal" | "small";
  $variant?: "dark" | "light";
};
export const StyledContentReaction = styled(ContentReaction, {
  ...transientOptions,
})<ContentReactionProps>`
  ${props =>
    props.$variant === "dark"
      ? css`
          background-color: unset;
          ${StyledIconUpvoteOn} {
            path {
              fill: #ffffff;
            }
          }
          path:last-of-type {
            stroke: #ffffff;
          }

          ${ContentReactionCount} {
            color: #ffffff;
          }
        `
      : css`
          path:last-of-type {
            stroke: #001246;
          }

          ${ContentReactionCount} {
            color: #001246;
          }
        `}

  ${ContentReactionButton} {
    inline-size: 25px;
    block-size: 28px;
    padding: 0;

    ${props =>
      props.$size === "small" &&
      css`
        inline-size: 19px;
        block-size: 23px;
      `}
  }
`;
